module.exports = __webpack_public_path__ + "media/images/common/order_btn2_l-559c045cd2286786f4c9bc43b983803a.png";